import type {MessageDescriptor} from "@lingui/core";
import {msg} from "@lingui/core/macro";
import {Trans, useLingui} from "@lingui/react/macro";
import {Col, Row, Text} from "../../ui/Box";
import Button from "../../ui/Button";
import type {RecipeOrder} from "./recipe-order";
import {updateRecipeView, useRecipeView} from "./use-recipe-view";

const orders: {order: RecipeOrder; label: MessageDescriptor}[] = [
  {order: "name", label: msg`Alphabetical`},
  {order: "lastCooked", label: msg`Last cooked`},
  {order: "countLastYear", label: msg`Most cooked in the last 12 months`},
  {order: "countTotal", label: msg`Most cooked overall`},
];

/** Picks how the cook page orders its recipes, and whether it shows section headings. */
const RecipeViewPicker = () => {
  const {i18n} = useLingui();
  const view = useRecipeView();
  return (
    <Col sp="24" maxWidth="formWidth" width="100%" mr="auto" ml="auto" pb="24">
      <Col sp="8">
        <Text as="h3" color="secondary" size="14_tight" weight="bold">
          <Trans>Order</Trans>
        </Text>
        <Col sp="4" align="start">
          {orders.map(({order, label}) => (
            <Button
              key={order}
              variant="secondary"
              active={view.order === order}
              onClick={() => updateRecipeView({order})}
            >
              {i18n._(label)}
            </Button>
          ))}
        </Col>
      </Col>
      <Row as="label" sp="8" align="center">
        <input
          type="checkbox"
          checked={view.compact}
          onChange={(e) => updateRecipeView({compact: e.target.checked})}
        />
        <Text color="primary" size="14_tight" weight="bold">
          <Trans>Compact</Trans>
        </Text>
      </Row>
    </Col>
  );
};

export default RecipeViewPicker;
